import { render, staticRenderFns } from "./c-room-inventory.vue?vue&type=template&id=be1fdb3c&"
import script from "./c-room-inventory.vue?vue&type=script&lang=js&"
export * from "./c-room-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports